import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { LocalStorage, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { PiteamService } from 'src/app/appServices/DefineService/piTeam-service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import * as FileSaver from 'file-saver'; // FOR SAVING EXCEL FILE
import { Workbook } from 'exceljs';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { createUserTypeOptions, object } from '../../../../shared/shared';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
import { facilitySystemList, roleList, userList } from 'src/app/appWeb/shared/shared-interface';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';

@Component({
  selector: 'app-create-users',
  templateUrl: './create-users.component.html',
  styleUrls: ['./create-users.component.scss'],
})
export class CreateUsersComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  @ViewChild('dt') quarter: Table | undefined;

  usersList: Array<userList> = [];
  totalRecords:number = 0;
  pageNumber:number = 1;
  rows:number = 15;
  sortOrder:string = "DESC";
  sortCol:string = "";
  filterVal:string = "";
  searchField:string = "";
  Roles: any = {};
  States: any = {};
  createScreenBool:boolean = false;
  form!: FormGroup;
  comfirmPasswordMatchBool:boolean = false;
  buttonText:string = "Save";
  cols: any;
  UId: string | null = '';
  UName: string | null = '';
  editUserList: any;
  rolesList: Array<roleList> = [];
  noRecordBool:boolean = false;
  showProgressSpinner: boolean = false;
  invalidEmailBool:boolean = false;
  disableEditProfile:boolean = false;
  disabledButton: boolean = false;
  //Profile Image
  invalidUploadfile: boolean = false;
  imageUrl?: any;
  imageUrlToShow: any;
  crateUserHeading:string = "";
  displayBackButton: boolean = false;
  loading = [false, false, false, false];
  UploadbtnDisplay: boolean = true;
  isAccessReadWrite: boolean = false;
  isAccessRead: boolean = false;
  roleAccessResult: Array<any> = [];
  RoleName: string = '';  
  facilityList: Array<facilitySystemList> = [];
  systemList: Array<facilitySystemList> = [];
  selectedFacility: Array<string> = [];
  selectedSystem: Array<string> = [];
  systemListTemp:Array<facilitySystemList> = [];
  selectedUserType:string = '';
  userTypeOptions=createUserTypeOptions;
  facilityListTemp:Array<facilitySystemList> = [];
  data:any = {};
  excelBool: boolean = false;
  exportExcelLoader: boolean = false;
  datePipe = new DatePipe('en-US');
  editScreen: boolean = false;
  private subscription: Subscription[] = [];
  roleForFacility: boolean = false;
  profileCheckBoxBool: boolean = false;
  crossSearchBool: boolean = false;

  constructor(
    public PiTeamService: PiteamService,
    private fb: FormBuilder,
    public messageService: MessageService,
    private helperService: HelperService,
    private toastService: ToasterService,
    private analyzeService: AnalyzeService,
    private router: Router,
    private route: ActivatedRoute,
    private accessControlService: AccessControlService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.UName = this.helperService.decryption(localStorage.getItem(LocalStorage.UName));
    this.imageUrlToShow = this.helperService.decryption(localStorage.getItem(LocalStorage.UserImageUrl)).toString();
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.roleForFacility = this.authService.roleForFacility();
    this.subscription.push(
    this.route.queryParamMap.subscribe((params:any) => {
      if(Boolean(params.get('getUserDetail'))){
      const getCase = params.get('getUserDetail');
      const getCaseDetail = Boolean(getCase);
      const edit = params.get('editScreen');
      this.editScreen = Boolean(edit);
      const UserId = params.get('UserId')
      const screenStatus = params.get('screenStatus');
      
      if (getCaseDetail && screenStatus == 'Edit') {
        this.GetUserDetailById(UserId);
      }else if(getCaseDetail && screenStatus == 'View'){
        this.GetUserDetailById(UserId);
        this.buttonText = 'Update';
        this.isAccessRead = true;
      }
     
      if (this.editScreen) {
        this.createScreenBool = true;
        const accessData = this.accessControlService.checkAccess( MenuItemsAccess.QMSUsersRead, MenuItemsAccess.QMSUsersReadWrite);
        this.isAccessRead = accessData.isAccessRead;
        this.isAccessReadWrite = accessData.isAccessReadWrite;
      }
      this.analyzeService.ClearQueryParams();
    }
    })
    );

    this.createForm();
    this.PiTeamService._createUsersComponent = this;
    // this.getAllValuesOfFilter();
    //user comes from header to edit profile
    if (this.PiTeamService._profileEdit == true) {
      this.editLoggedUser();
      this.UploadbtnDisplay = true;
      this.profileCheckBoxBool = true;
    } else {
      this.UploadbtnDisplay = false;
      this.profileCheckBoxBool = false;
    }
    // this.GetRoles();
  }

  editLoggedUser() {
    this.GetUserDetailById(this.UId);
    this.disableEditProfile = true;
    this.UploadbtnDisplay = true;
    this.profileCheckBoxBool = true;

  }

  SideNavLoggedUser() {
    this.createScreenBool = false;
    this.searchField = '';
  }

  createForm() {
    this.form = this.fb.group({
      Id: [""],
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      UserInitial: ['', Validators.maxLength(6)],
      UserName: ['', Validators.required],
      Email: ['', [Validators.required, Validators.email]],
      Password: ['', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]],
      ConfirmPassword: ['', Validators.required],
      MobilePhone: ['', Validators.required],
      OtherPhone: [''],
      NPINumber: ['', Validators.minLength(10)],
      file: [''],
      Address_line1: [''],
      Address_line2: [''],
      City: [''],
      State_key: [0],
      Zip: [''],
      TwoFactorEnabled: [false],
      EnableFive9: [false],
      CaseReviewer: [false],
      IsEEG: [false],
      IsActive: [false],
      //Extra
      isDisable: [true],
      Role: [''],
      RoleId: [[], Validators.required],
      Level: [''],
      APISecretKey: [''],
      APIPassword: [''],
      UsertType: [''],
      IsStrokeAlert: [true],
      NHAlert: [true],
      IsSleep: [true],
      IsTelePsych: [true],
      IsPediatricNeurology: [true],
      IsPediatricEEG: [true],
      IsSupplemental: [true],  
    },
      { validators: passwordMatchingValidatior })
  }

  get f() {
    return this.form.controls
  }

  getAllUsers() {
    this.showProgressSpinner = true;
    let data = {
      Take: this.rows,
      Skip: (this.rows * this.pageNumber) - this.rows,
      Sort:
      {
        FieldName: this.sortCol,
        Order: this.sortOrder
      },
      Filters: [
        {
          FieldName: 'facilityIDs',
          value: this.selectedFacility.join(',')
        },
      ],
      Filter: {
        field: "",
        operator: "",
        value: this.searchField,
        logic: "",
        filters: []
      },
      searchString: this.searchField,
      PageNumber: this.pageNumber,
      serviceType: [],
      roleIDs: [this.selectedUserType.toString()],
    }
    this.data = data;
    this.subscription.push(
    this.PiTeamService.GetAllUsers(data, this.selectedSystem, this.RoleName, this.UId).subscribe({
      next: (res: any) => {
        if (res.data.length == 0) { this.noRecordBool = true; }
        else { this.noRecordBool = false; }
        this.usersList = res.data;
        this.totalRecords = res.Total ? res.Total : 0;
        this.showProgressSpinner = false;
        this.PiTeamService.currentDateTime();
        // this.CheckRoleAccess();
        const accessData = this.accessControlService.checkAccess( MenuItemsAccess.QMSUsersRead, MenuItemsAccess.QMSUsersReadWrite);
        this.isAccessRead = accessData.isAccessRead;
        this.isAccessReadWrite = accessData.isAccessReadWrite;
      },
      error: (err: any) => { },
    })
    );
  }

  applyFilterGlobal($event: any, stringVal: any) {
    const inputValue = ($event.target as HTMLInputElement).value;
    this.dt!.filterGlobal(inputValue, stringVal);
    if(inputValue !== ''){
      this.crossSearchBool = true;
    }else{
    this.crossSearchBool = false;
    }
  }
  clearSearchField() {
    this.crossSearchBool = false;
    this.searchField = '';
    this.getAllUsers();
  }

  lazyLoadSchedules(event: any): void {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = (event.first / this.rows) + 1;
      this.sortOrder = (event.multiSortMeta == undefined || event.multiSortMeta[0].order == 1) ? 'ASC' : 'DESC';
      this.sortCol = (event.multiSortMeta == undefined) ? '' : event.multiSortMeta[0].field;
      this.searchField.length > 0 ? this.crossSearchBool = true : this.crossSearchBool = false;
      // this.searchField = event.filters.global == undefined ? '' : event.filters.global.value;
      this.getAllUsers();
    }
  }


  addUser() {
    this.form.reset();
    this.createForm();
    this.buttonText = "Save";
    this.createScreenBool = true;
    this.disableEditProfile = false;
    this.disabledButton = true;
    this.UploadbtnDisplay = false;
  }

  submit() {
    if (!this.invalidEmailBool) {
      this.loading[0] = true;
    }
    else if (this.invalidEmailBool) {
      this.loading[1] = true;
    }
    this.disabledButton = true;
    this.disabledButton = true;
    if (this.form.value.State_key != undefined) {
      this.form.patchValue({ State_key: this.form.value.State_key });
    } else {
      this.form.patchValue({ State_key: 0 });
    }
    this.showProgressSpinner = true;
    this.subscription.push(
    this.PiTeamService.CreateUser(this.form.value, this.UId, this.UName).subscribe({
      next: (res: any) => {
        if (res.status == -1) {
          this.toastService.customErr(res.msg);
          this.createScreenBool = true;
        }
        else {
          this.toastService.message("User Added Successfuly.");
          this.createScreenBool = false;
        }
        this.showProgressSpinner = false;

        localStorage.removeItem('editUserId');
        if (!this.invalidEmailBool) {
          this.loading[0] = false;
        }
        else if (this.invalidEmailBool) {
          this.loading[1] = false;
        }
      },
      error: (err: any) => {
      },
    })
    );
  }

  updateUserApiHit() {
    if (!this.invalidEmailBool) {
      this.loading[2] = true;
    }
    else if (this.invalidEmailBool) {
      this.loading[3] = true;
    }

    if (this.form.value.State_key != undefined) {
      this.form.patchValue({ State_key: this.form.value.State_key });
    } else {
      this.form.patchValue({ State_key: 0 });
    }

    this.showProgressSpinner = true;

    if (this.imageUrl && this.imageUrl != null && this.imageUrl != undefined) {
      this.saveUserProfileImage();
    }
    else {
      this.saveUserFromData();
    }
  }

  saveUserProfileImage() {
    let formData: any = new FormData();
    formData.append('fileUpload', this.imageUrl, this.imageUrl.name);
    this.subscription.push(
    this.PiTeamService.UploadProfileImageOnSave(formData).subscribe({
      next: (res: any) => {
        let imageName = res.data;
        this.saveUserFromData(imageName);
      },
      error: (err: any) => {
        this.showProgressSpinner = false;
        if (!this.disableEditProfile) {
          this.createScreenBool = false;
        }
        this.loading[2] = false;
        this.loading[3] = false;
        this.toastService.customErr("Something went wrong.");

      },
    })
    );
  }

  saveUserFromData(imageName: string = "") {
    this.form.patchValue({ file: imageName });
    let editUserProfileObj = {
      userViewModel: this.form.value,
      modifiedBy: this.UId,
      modifiedByName: this.UName
    }
    this.subscription.push(
    this.PiTeamService.UpdateUser(editUserProfileObj).subscribe({
      next: (res: any) => {
        this.showProgressSpinner = false;
        if (!this.disableEditProfile) {
          this.createScreenBool = false;
        }
        if (res.status == -1) {
          this.toastService.customErr(res.msg);
          this.createScreenBool = true;
        }
        else {
          this.toastService.message("User Updated Successfuly.");
        }
        this.loading[2] = false;
        this.loading[3] = false;
      },
      error: (err: any) => {
        this.showProgressSpinner = false;
        if (!this.disableEditProfile) {
          this.createScreenBool = false;
        }
        this.loading[2] = false;
        this.loading[3] = false;
        this.toastService.customErr("Something went wrong.");

      },
    })
    );
  }

  backToSuperAdmin() {
    this.messageService.clear();
    this.messageService.add({ key: 'c', sticky: true, severity: 'custom', summary: 'Are you sure you want to close out of this page?' });
  }

  onConfirm() {
    this.createScreenBool = false;
    this.profileCheckBoxBool = false;

    this.buttonText = "Save";
    localStorage.removeItem('editUserId');
    this.messageService.clear();
  }

  onReject() {
    this.messageService.clear();
  }

  hasError = (controlName: string, errorName: string) => {
    return this.form.controls[controlName].hasError(errorName);
  }

  passwordMatch() {
    if ((this.form.value.Password != "") && (this.form.value.ConfirmPassword != "")) {
      if (this.form.value.Password != this.form.value.ConfirmPassword) {
        this.comfirmPasswordMatchBool = true;
      }
      else {
        this.comfirmPasswordMatchBool = false;
      }
    }
  }

  GetAllData(val:string){
    if((this.facilityList.length === 0 && val == 'facility') || 
    (this.systemList.length === 0 && val == 'system')){
      this.showProgressSpinner = true;
    let obj = object;
    if(val == 'system'){
      obj.FieldName = 'ucd_ucl_key';
      obj.Value = '42';
    }else
    {
      obj.FieldName = 'facility';
      obj.Value = 'facility';
    }
    this.subscription.push(
      this.analyzeService.GetAllData(obj,this.RoleName,this.UId).subscribe({
        next: (res: any) => {
          if (res) {
            this.showProgressSpinner = false;
            if(val == 'system'){
              this.systemList = res.data;
              this.systemListTemp = res.data;
            }else{
              this.facilityList = res.data;
              this.facilityListTemp = res.data;
            }
          }
        },
        error: (err: any) => { },
      })
      );
    }
  }
  GetUserDetailById(usersList: any) {

    this.disabledButton = true;
    this.showProgressSpinner = true;
    this.disableEditProfile = false;
    this.PiTeamService._profileEdit = false;
    let UserEditProfile = localStorage.getItem(LocalStorage.UserEditProfile);
    this.subscription.push(
    this.PiTeamService.GetUserDetailById(usersList).subscribe({
      next: (res: any) => {
        this.editUserList = res.data[0];
        this.rolesList = res.AllRoles;
        this.States = res.getAllStates;
        this.showProgressSpinner = false;
        this.editUserList != undefined ? this.editUserList.RoleId = this.editUserList?.RoleId.split(',') : '';
        this.createScreenBool = true;
        this.buttonText = "Update";
        if (UserEditProfile == "true") {
          this.crateUserHeading = "Edit User profile";
          this.displayBackButton = false;
        } else {
          this.crateUserHeading = "Update User";
          this.displayBackButton = true;
        }
        this.createForm();
        this.form.patchValue(this.editUserList);
        this.form.controls['Password'].clearValidators();
        this.form.controls['ConfirmPassword'].clearValidators();
      }
    })
    );

  }

  removeUserProfileCheck() {
    this.UploadbtnDisplay = false;
    localStorage.removeItem(LocalStorage.UserEditProfile);
  }

  ValidateEmail() {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.form.value.Email) || this.form.value.Email == "") { this.invalidEmailBool = false; }
    else { this.invalidEmailBool = true; }
  }

  OnMultiSelectChange(){
    this.getAllUsers();
  }
  //Profile Image
  onProfileImageChange(event: any): void {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      this.imageUrl = file;
    }
    let reader = new FileReader();
    let file = event.target.files[0];
    if (file.type.includes('image')) {
      this.invalidUploadfile = false;
      if (file) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.imageUrlToShow = "";
          this.imageUrlToShow = reader.result;
          this.form.patchValue({
            userImage: reader.result
          });
        }
      }
    } else {
      this.imageUrl = null;
      this.imageUrlToShow = null;
      this.invalidUploadfile = true
      setTimeout(() => {
        this.invalidUploadfile = false
      }, 3000);
    }
  }
  GetFacility(){
    if(this.selectedSystem.length > 0){
      this.subscription.push(
      this.analyzeService.GetFacilityBySystem(this.selectedSystem).subscribe({
        next: (res: any) => {
          if(res){
            this.facilityList = res.data.data;
            this.getAllUsers();
          }
        },
        error: (err: any) => { 
        },
      })
      );
    }else{
      this.selectedFacility = [];
      this.facilityList = this.facilityListTemp;
      this.systemList = this.systemListTemp;
      this.getAllUsers();
    }
  }
  GetRolesAndStates(){
    if(this.rolesList.length === 0 || this.States.length === 0){
    this.subscription.push(
    this.PiTeamService.GetAllStatesAndRoles().subscribe({
      next: (res: any) => {
        this.rolesList = res.AllRoles;
        this.States = res.getAllStates;
      }
    })
    );
  }
  }

  excelDownload(workbook: any, fileName: any) {
    workbook.xlsx.writeBuffer().then((data: any) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, fileName + '.xlsx');
    })
  }

  exportExcel() {
    this.excelBool = true;
    this.exportExcelLoader = true;
    let newArray: any = [];
    let usersList: any = [];
    this.data.Take = 0;
    this.data.Skip = 0;
    this.subscription.push(
    this.PiTeamService.GetAllUsers(this.data, this.selectedSystem, this.RoleName, this.UId).subscribe({
      next: (res: any) => {
        if (res) {
          usersList = res.data;
          if(usersList.length > 0){
            usersList.forEach((item:any)=>{
              let UserLoginTime:any;
              let IsActive: any;
              if(item.UserLoginTime){
                UserLoginTime = this.datePipe.transform(item.UserLoginTime,'MM/dd/yyyy hh:mm:ss');
              }
              if(item.IsActive == true){
                IsActive = 'Yes'
              }else{
                IsActive = 'No'
              }
              
                newArray.push({UserName: item.UserName,FirstName: item.FirstName,LastName: item.LastName,
                  MobilePhone: item.MobilePhone ,Email: item.Email,RoleName: item.RoleName,
                  UserInitial: item.UserInitial,UserLoginTime: UserLoginTime,IsActive: IsActive});
            })
          }

          let dataForExcel: any = [];
          let workbook = new Workbook();
          let worksheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: '36286B' }, outlineLevelRow: 1 } });
          worksheet.columns = [
            { header: 'Username', key: 'Username', width: 25 },
            { header: 'First Name', key: 'First Name ', width: 25 },
            { header: 'Last Name', key: 'Last Name', width: 25 },
            { header: 'Phone', key: 'Phone', width: 20 },
            { header: 'Email', key: 'Email', width: 25 },
            { header: 'TeleCare User Type', key: 'TeleCare User Type', width: 25 },
            { header: 'Initials', key: 'Initials', width: 25 },
            { header: 'Last Login Time', key: 'Last Login Time', width: 25 },
            { header: 'Active', key: 'Active', width: 15 }
          ]
          worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
            row.eachCell((cell, number) => {
              cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '767C88' },
                bgColor: { argb: '' },
    
              }
              cell.font = {
                bold: true,
                color: { argb: 'FFFFFF' },
                size: 12,
              }
            })
          })
          newArray.forEach((element: any) => {
            dataForExcel.push(Object.values(element))
          });
    
          dataForExcel.forEach((d: any) => {
            let row = worksheet.addRow(d);
          })
          this.excelDownload(workbook, "Users");
          this.exportExcelLoader = false;
        }
      },
      error: (err: any) => { },
    })
    );
    
  }


  onContextMenu(event:MouseEvent, UId:string,status:string){
    event.preventDefault();
    const queryParams = {
      getUserDetail: true,
      editScreen: true,
      UserId: UId,
      screenStatus:status
    };
    const url = this.router.createUrlTree(['/Home/Define/Users'], { queryParams });
    window.open(url.toString(), '_blank');
  }

  onContextMenuPreventDefault(event:any){
    event.preventDefault();
  }

  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
    
    Object.getOwnPropertyNames(this)
    .filter(propName => Array.isArray((<any>this)[propName]))
    .forEach(propName => (<any>this)[propName] = []);
  }

}
export const passwordMatchingValidatior: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const password = control.get('Password');
  const confirmPassword = control.get('ConfirmPassword');
  return password?.value === confirmPassword?.value ? null : { notmatched: true };
};
